module.exports = __webpack_public_path__ + "fonts/icomoon-bold.8a0979f.woff";